import {
  Category,
  PayloadCategory,
  PayloadCategorySequence,
} from '@/types/category'
import { api } from '@/utils/api'
import { apiCategoryId, apiCategorySequence } from '@/utils/api/url'
import { createRouteForAPI } from '@/utils/helpers/urlHelper'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { App } from 'antd'
import { QUERY_KEY_CATEGORY } from './useGetCategories'
import { useTranslation } from 'react-i18next'
import { queryClient } from '@/configs/tanstack'

const messageKey = 'update-category'
export const useUpdateCategory = () => {
  const { t } = useTranslation('catalog')
  const queryClient = useQueryClient()
  const { message } = App.useApp()
  const category = useMutation({
    mutationFn: ({
      branch,
      id,
      payload,
    }: {
      branch: string
      id: string
      payload: PayloadCategory
    }) =>
      api
        .put(createRouteForAPI(apiCategoryId, { branch, id }), payload)
        .then(({ data }) => data as Category),
    onMutate: () => {
      message.loading({
        key: messageKey,
        content: t('catalog.category.updating'),
      })
    },
    onSuccess: (_, payload) => {
      message.success({
        key: messageKey,
        content: t('catalog.category.updated'),
      })
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEY_CATEGORY, payload.branch],
      })
    },
    onError: () => {
      message.destroy(messageKey)
    },
  })

  return category
}

export const useUpdateCategorySequence = () => {
  const category = useMutation({
    mutationFn: ({
      branch,
      payload,
    }: {
      branch: string
      payload: PayloadCategorySequence[]
    }) =>
      api
        .post(createRouteForAPI(apiCategorySequence, { branch }), payload)
        .then(({ data }) => data as Category[]),
    onSuccess: (_, payload) => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEY_CATEGORY, payload.branch],
      })
    },
  })

  return category
}
